<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-number"><a id="page1"></a><a href="#/005_TOC#toc-part1" id="part1"><b>P<span class="small">ART</span> O<span class="small">NE</span></b></a></h1>
<h1 class="part-title"><a href="#/005_TOC#toc-part1"><b>Historians in the Making</b></a></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Part1.vue?d0335be2